exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blink[data-v-09a12fc8]{animation:blink-data-v-09a12fc8 1s infinite}@keyframes blink-data-v-09a12fc8{0%,to{opacity:1}50%{opacity:.2}}", ""]);

// exports
